import styled from 'styled-components'
import { LinkButton } from '../../components/button/link-button'

export const Main = styled.main`
  flex: 1;
  margin-top: 72px;
  width: 100%;
`

export const Container = styled.div`
  display: flex;
  position: relative;
  width: 100%;

  @media (max-width: 911px) {
    flex-direction: column;
  }
`

export const Banner = styled.figure`
  aspect-ratio: 629 / 698;
  height: calc(100vh - 72px);
  left: 0;
  overflow: hidden;
  position: sticky;
  top: 0;
  width: 100%;

  & > img {
    width: 100%;
  }

  @media (max-width: 911px) {
    max-width: 100%;
    height: initial;
    position: initial;
    overflow: initial;
  }
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  max-height: calc(100vh - 72px);
  overflow-y: auto;
  width: 100%;

  @media (max-width: 911px)  {
    overflow: initial;
  }
  `

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 32px;
  padding: 62px 62px 110px;
  width: 100%;

  @media (max-width: 911px)  {
    padding: 32px 24px 62px;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & > h1 {
    color: #1D1D1D;
    font-size: 32px;
    font-weight: 700;
    line-height: 120%;
  }

  & > small {
    font-size: 16px;
    font-weight: 400;
    line-height: 120%;
  }
`

export const RegistrationContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;

  & > small {
    color: #1D1D1D;
    font-size: 14px;
    font-weight: 400;
    line-height: 120%;
    text-align: center;
  }
`

export const Registration = styled.div`
  align-items: center;
  background-color: #FCF8EF;
  border: 1px solid #E0E0E0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px;
  width: 100%;

  & > small {
    color: #1D1D1D;
    font-size: 14px;
    font-weight: 300;
    line-height: 22px;
  }

  & > p {
    color: #1D1D1D;
    font-size: 24px;
    font-weight: 700;
    line-height: 40px;
    vertical-align: middle;
  }
`

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  & > h2 {
    color: #1D1D1D;
    font-weight: 700;
    font-size: 24px;
    line-height: 120%;
  }

  & > ul {
    display: flex;
    flex-direction: column;
    gap: 8px;
    list-style: none;

    & > li {
      align-items: center;
      color: #1D1D1D;
      display: inline-flex;
      font-size: 1rem;
      gap: 12px;
    }
  }

  & > p {
    color: #1D1D1D;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
  }

  @media (max-width: 568px) {
    & > ul {
      & > li {
        font-size: 0.875rem;
      }
    }
  }
`

export const StoresContainer = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
`

export const Link = styled(LinkButton)`
  align-self: center;
  font-size: 1rem;
  line-height: 140%;
  padding: 8px 32px;
`
